import styled from '@emotion/styled';
import { Flex } from '$components/layouts';
import { mq } from '$lib/helpers';

export const OverlayBottomContainer = styled(Flex)<{ isApp?: boolean }>(({ theme, isApp }) => ({
    bottom: 0,
    left: 0,
    right: 0,
    marginTop: theme.space[5],
    padding: `${theme.space[3]} ${theme.space[6]} ${theme.space[8]}`,
    width: '100%',
    borderTop: theme.general.border,
    backgroundColor: theme.colors.white,
    position: isApp ? 'initial' : 'fixed',

    [mq('sm')]: {
        paddingLeft: isApp ? 0 : `${theme.space[9]}`,
        paddingRight: isApp ? 0 : `${theme.space[9]}`,
    },

    [mq('md')]: {
        paddingTop: `${theme.space[2]}`,
    },
}));
